(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      // Use a ResizeObserver for more reliable height updates if available, or fallback to matchMedia
      if (typeof ResizeObserver === 'function') {
        this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.resizeObserver.observe(this.header);
      } else {
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      }


      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true }); // Added passive true

      this.createObserver();

      this.isTransparentHeaderDesktop = this.hasAttribute('data-transparent-header-desktop');
      this.isTransparentHeaderMobile = this.hasAttribute('data-transparent-header-mobile');
      this.isTransparentHeader = this.isTransparentHeaderDesktop || this.isTransparentHeaderMobile;
      if (this.isTransparentHeader) {
        this.initTransparentHeader();
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    isDesktop() {
      return window.innerWidth >= 990;
    }

    initTransparentHeader() {
      const announcementBar = document.querySelector('.announcement-bar-section');
      this.announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBarHeight}px`);

      this.onHeaderMouseEnter = () => { if (this.isDesktop()) document.body.classList.add('header-hovered'); };
      this.onHeaderMouseLeave = () => document.body.classList.remove('header-hovered');
      this.addEventListener('mouseenter', this.onHeaderMouseEnter);
      this.addEventListener('mouseleave', this.onHeaderMouseLeave);

      this.isInvertedHeader = this.hasAttribute('data-invert-header');

      // Set correct initial state for current viewport
      this._applyTransparentClasses();

      // Handle viewport resize crossing the 990px breakpoint
      this.onResizeTransparent = () => { this._applyTransparentClasses(); };
      window.addEventListener('resize', this.onResizeTransparent);
    }

    _applyTransparentClasses() {
      const desktop = this.isDesktop();
      const enabledForViewport = (desktop && this.isTransparentHeaderDesktop) || (!desktop && this.isTransparentHeaderMobile);
      if (enabledForViewport) {
        document.body.classList.add('transparent-header-mode');
        if (this.isInvertedHeader) document.body.classList.add('transparent-header-inverted');
        if (window.pageYOffset > this.announcementBarHeight) {
          document.body.classList.add('header-scrolled');
        }
      } else {
        document.body.classList.remove('transparent-header-mode', 'transparent-header-inverted', 'header-scrolled', 'header-hovered');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.isTransparentHeader) {
        this.removeEventListener('mouseenter', this.onHeaderMouseEnter);
        this.removeEventListener('mouseleave', this.onHeaderMouseLeave);
        window.removeEventListener('resize', this.onResizeTransparent);
        document.body.classList.remove('transparent-header-mode', 'transparent-header-inverted', 'header-scrolled', 'header-hovered');
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      const transparentActive = (this.isDesktop() && this.isTransparentHeaderDesktop) || (!this.isDesktop() && this.isTransparentHeaderMobile);
      if (transparentActive) {
        if (scrollTop > this.announcementBarHeight) {
          document.body.classList.add('header-scrolled');
        } else {
          document.body.classList.remove('header-scrolled');
        }
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return; // Typo: should be this.preventReveal or similar logic
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky && this.getAttribute('data-sticky-type') !== 'on-scroll-up') return; // Adjusted condition
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      // Always reveal if scrolling up, unless it's 'always' sticky and not 'reduce-logo-size'
      if (this.headerIsAlwaysSticky && this.getAttribute('data-sticky-type') !== 'on-scroll-up' && this.getAttribute('data-sticky-type') !== 'reduce-logo-size') return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => {
        if (disclosure.close) disclosure.close();
        else if (disclosure.querySelector('[aria-expanded="true"]')) { // Fallback for details/summary
            const summary = disclosure.querySelector('summary');
            if (summary) summary.click(); // This might not always work as expected for custom elements
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && this.searchModal.close) { // Check if searchModal and its close method exist
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
